class PasswordEye extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.toggle.bind(this));
    // Nascondi l'icona inactive all'inizializzazione
    const inactiveIcon = this.querySelector('.inactive');
    if (inactiveIcon) {
      inactiveIcon.style.display = 'none';
    }
  }

  toggle() {
    const inputGroup = this.closest('.input-group');
    if (!inputGroup) return;

    const input = inputGroup.querySelector('input[type="password"], input[type="text"]');
    if (!input) return;

    const activeIcon = this.querySelector('.active');
    const inactiveIcon = this.querySelector('.inactive');

    if (input.type === 'password') {
      input.type = 'text';
      if (activeIcon) {
        activeIcon.style.display = 'none';
        activeIcon.classList.remove('active');
        activeIcon.classList.add('inactive');
      }
      if (inactiveIcon) {
        inactiveIcon.style.display = 'block';
        inactiveIcon.classList.remove('inactive');
        inactiveIcon.classList.add('active');
      }
    } else {
      input.type = 'password';
      if (activeIcon) {
        activeIcon.style.display = 'block';
        activeIcon.classList.remove('inactive');
        activeIcon.classList.add('active');
      }
      if (inactiveIcon) {
        inactiveIcon.style.display = 'none';
        inactiveIcon.classList.remove('active');
        inactiveIcon.classList.add('inactive');
      }
    }
  }
}

if (!customElements.get('mc-password-eye')) {
  customElements.define('mc-password-eye', PasswordEye);
}
